export function copyToChannel(source: Float32Array, channelNumber: number, startInChannel = 0) {
  const clipped = source.subarray(0, Math.min(source.length, this.length - startInChannel));

  this.getChannelData(channelNumber).set(clipped, startInChannel);
}



// WEBPACK FOOTER //
// ./src/polyfills/copy-to-channel.ts